<script>
import options from "./BuySection.options";
export default options;
</script>

<template v-if="variantData">
  <section class="kb-buy-section" aria-live="polite">
    <template v-if="!soldOutText">
      <div class="kb-buy-section__price-wrapper">
        <p class="kb-buy-section__price">
          {{ currentVariant.price.displayPrice }}
        </p>

        <template v-if="currentVariant.price.displayBeforePrice">
          <h5 class="kb-buy-section__price--before">
            {{ getLabel("prePriceText") }}
            <span class="kb-buy-section__price--before-price">{{
              currentVariant.price.displayBeforePrice
            }}</span>
          </h5>
        </template>
      </div>
      <template v-if="variantData.variantList.length > 2">
        <article class="kb-selector kb-variant-selector">
          <label class="kb-variant-selector__label" for="variant-selector">{{ variantData.variantList[0].displayName }}</label>
          <div class="kb-selector__wrapper kb-selector__wrapper--with-arrow">
            
            <select
              id="variant-selector"
              v-model="currentVariantSku"
              @change="updateDisplayNoVariantChosenMessage"
            >
              <template
                v-for="(variant, index) in variantData.variantList"
                :key="index"
              >
                <option
                  :value="variant.sku"
                  :disabled="index === 0 || variant.outOfStock"
                  :selected="index === 0"
                >
                  {{ variant.displayName }}
                </option>
              </template>
            </select>
          </div>
        </article>
      </template>

      <div class="kb-buy-section__amount-add-wrapper">
        <AmountSelector
          id="amountSelector"
          :setAmount="setAmount"
          :startAmount="variantData.minAmount"
          :minAmount="variantData.minAmount"
          :maxAmount="variantData.maxAmount"
          :displayMessage="displayMessage"
          :sku="currentVariantSku"
          :label="getLabel('addToCartAmount', [], true)"
          aria-describedby="errorMessageMinAmount errorMessageNoVariantChosen errorMessageMissingRole"
        />

        <button
          @click="addToCart"
          class="kb-buy-section__add-to-cart-button kb-button kb-button--full-color-spot"
          v-if="hasRequiredRights"
        >
          {{ getLabel("addToCartButtonText") }}
        </button>

        <button
          @click="openRequestRoleOverlay"
          class="kb-buy-section__open-wrong-role-overlay-button kb-button kb-button--full-color-spot"
         v-else
        >
          {{ getLabel("requestAccessButtonText") }}
        </button>

      </div>
      <!-- error message if more than max chosen -->
      <p
        id="errorMessageMaxAmount"
        :class="displayMaxAmountMessage"
        class="kb-product-detail__error-message"
      >
        {{
          getLabel("errorMessageMaxAmount", [`${variantData.maxAmount}`])
        }}
      </p>

      <!-- error message if more less than min chosen -->
      <p
        id="errorMessageMinAmount"
        :class="displayMinAmountMessage"
        class="kb-product-detail__error-message kb-product-detail__error-message--no-margin"
        role="alert"
      >
        {{
          getLabel("errorMessageMinAmount", [`${variantData.minAmount}`])
        }}
      </p>

      <!-- error message if no variant chosen -->
      <p
        id="errorMessageNoVariantChosen"
        :class="displayNoVariantChosenMessage"
        class="kb-product-detail__error-message kb-product-detail__error-message--no-margin"
      >
        {{ getLabel("errorMessageNoVariantChosen") }}
      </p>

      <p class="kb-visually-hidden" aria-live="polite">
        {{  displayMaxAmountMessage ?  getLabel("errorMessageMaxAmount", [`${variantData.maxAmount}`]) : null}}
        {{  displayMinAmountMessage ?  getLabel("errorMessageMinAmount", [`${variantData.minAmount}`]) : null}}
        {{  displayNoVariantChosenMessage ? getLabel("errorMessageMinAmount", [`${variantData.minAmount}`]) : null }}
      </p>
    </template>

    <!-- error message if user is missing rights to order product -->
    <template v-if="!hasRequiredRights">
        <p
          id="errorMessageMissingRole"
          :class="displayHasRequiredRightsMessage"
          class="kb-product-detail__error-message kb-product-detail__error-message--no-margin"
          aria-live="assertive"
        >
          {{ getLabel("errorMessageMissingRole") }}
        </p>
    </template>

    <template v-if="soldOutText">
      <p class="kb-buy-section__sold-out kb-buy-section__sold-out--text">
        {{ soldOutText }}
      </p>
      <template v-if="soldOutReason">
        <p class="kb-buy-section__sold-out kb-buy-section__sold-out--reason">
          {{ soldOutReason }}
        </p>
      </template>
    </template>

    <template v-if="pdfData?.link">
      <a
        :href="pdfData.link"
        :title="pdfData.title"
        target="_blank"
        class="kb-buy-section__pdf-link"
        ><span>{{ pdfData.text }}</span></a
      >
    </template>
  </section>
</template>
